import { render, staticRenderFns } from "./InvoicesRecuringBap.vue?vue&type=template&id=1a95b354&"
import script from "./InvoicesRecuringBap.vue?vue&type=script&lang=ts&"
export * from "./InvoicesRecuringBap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a95b354')) {
      api.createRecord('1a95b354', component.options)
    } else {
      api.reload('1a95b354', component.options)
    }
    module.hot.accept("./InvoicesRecuringBap.vue?vue&type=template&id=1a95b354&", function () {
      api.rerender('1a95b354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-receivables/InvoicesRecuringBap.vue"
export default component.exports